import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from '../views/login/Login.vue'
import Register from '../views/register/Register.vue'
import Market from '@/views/index/Market.vue'
import Index from '@/views/index/Index.vue'
import ChangeInfo from '@/views/index/ChangeInfo.vue'
import Apps from '@/views/market/Apps.vue'
import Order from '@/views/market/Order.vue'
import Forget from '@/views/register/Forget.vue'
import Expend from '@/views/index/Expend.vue'
import Details from '@/views/market/Details.vue'
import Dashboard from '@/views/index/Dashboard.vue'
import QiniuSettings from '@/views/index/QiniuSettings.vue'
import Agent from '@/views/index/Agent.vue'  

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/market',
    name: 'market',
    component: Market,
    children: [
      {
        path: 'details',
        name: 'details',
        component: Details,

      },
    ]

  },
  {
    path: '/apps',
    name: 'apps',
    component: Apps,

  },
  {
    path: '/forget',
    name: 'forget',
    component: Forget,

  },

  {
    path: '/index',
    name: 'index',
    component: Index,
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard
      },
      {
        path: 'order',
        name: 'order',
        component: Order,

      },
      {
        path: 'ChangeInfo',
        name: 'ChangeInfo',
        component: ChangeInfo
      },
      {
        path: 'expend',
        name: 'expend',
        component: Expend
      },
      {
        path: 'apps',
        name: 'apps',
        component: Apps
      },
      {
        path: 'qiniu',
        name: 'qiniu',
        component: QiniuSettings
      },
      {
        path: 'agent',
        name: 'agent',
        component: Agent
      },

    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
